import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { trackCustomEvent } from "../../../services/utils/facebookPixel";

const initialState = {
    cartItems: localStorage.getItem("cartItems") ? JSON.parse(localStorage.getItem("cartItems")) : [],
    cartTotalQuantity: 0,
    cartTotalItems: 0,
    cartSubTotalAmount: 0,
    cartDeliveryCharge: 110
}

// Utility function to recalc totals
const calculateTotals = (state) => {
    const { total, quantity, items } = state.cartItems.reduce((acc, item, idx) => {
        acc.total += item.discountedPrice * item.cartQuantity;
        acc.quantity += item.cartQuantity;
        acc.items = idx + 1;
        return acc;
    }, { total: 0, quantity: 0, items: 0 });
    state.cartTotalQuantity = quantity;
    state.cartTotalItems = items;
    state.cartSubTotalAmount = total;
}

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart(state, action) {
            const itemIndex = state.cartItems.findIndex(item => item.id === action.payload.id);
            if (itemIndex >= 0) {
                state.cartItems[itemIndex].cartQuantity += 1;
                toast.success(`Increased ${state.cartItems[itemIndex].product_name} cart quantity`, {
                    position: 'top-center',
                });
            } else {
                const tempProduct = { ...action.payload, cartQuantity: 1 };
                state.cartItems.push(tempProduct);
                toast.success(`${action.payload.product_name} added to cart.`, {
                    position: 'top-center',
                });
                 // 🔥 Facebook Pixel Custom Event
                trackCustomEvent("AddToCart", {
                    content_name: action.payload.product_name,
                    value: action.payload.discountedPrice,
                    currency: "TK",
                    quantity: 1
                });
            }

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
            calculateTotals(state);
        },

        removeFromCart(state, action) {
            state.cartItems = state.cartItems.filter(cartItem => cartItem.id !== action.payload.id);
            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
            toast.error(`${action.payload.product_name} removed from cart.`, {
                position: 'top-center',
            });
            calculateTotals(state);
        },

        decreaseFromCart(state, action) {
            const itemIndex = state.cartItems.findIndex(cartItem => cartItem.id === action.payload.id);
            if (state.cartItems[itemIndex].cartQuantity > 1) {
                state.cartItems[itemIndex].cartQuantity -= 1;
                toast.success(`Decreased ${state.cartItems[itemIndex].product_name} cart quantity`, {
                    position: 'top-center',
                });
            } else if (state.cartItems[itemIndex].cartQuantity === 1) {
                state.cartItems = state.cartItems.filter(cartItem => cartItem.id !== action.payload.id);
                toast.error(`${action.payload.product_name} removed from cart.`, {
                    position: 'top-center',
                });
            }

            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
            calculateTotals(state);
        },

        clearCart(state) {
            if (state.cartItems.length > 0) {
                state.cartItems = [];
                toast.error(`Cart has been cleared.`, { position: 'top-center' });
                localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
                calculateTotals(state);
            }
        },

        getTotals(state) {
            calculateTotals(state);
        }
    }
});

export const { addToCart, removeFromCart, decreaseFromCart, clearCart, getTotals } = cartSlice.actions;
export default cartSlice.reducer;
